<template>
  <div class="import-finance-stage-sidebar">

    <div class="import-finance-stage-sidebar__row">
      <div class="import-finance-stage-sidebar__col import-finance-stage-sidebar__col50">
        <div class="import-finance-stage-sidebar__col-content" style="height: calc(100% - 15px);">
          <app-panel title="Сведение финансовой информации" style="height: 100%">
            <div>
              <ul class="import-finance-stage-sidebar__timeline">
                <li>Зайти под управляющим УК и выдать права на импортированный дом тестовому пользователю</li>
                <li>Перейти на страницу ”список счетов”, выбрать месяц с первыми начислениями и убедиться что начальное сальдо = 0. Если нет - Написать Юре</li>
                <li>Если первые начисления есть 3 года назад  - то нужен импорт начального сальдо</li>
                <li>Далее нужно проверить сальдо по месяцам. Название файла в формате YYYY-MM.xlsx</li>
                <li>Для сведения сальдо - конечное сальдо = начальное сальдо + начислено в периоде - оплачено в периоде. Что бы все сходилось - правим даты прихода платежей того аккаунта у которого сальдо у нас отличается от того что в квартале</li>
                <li>По вине квартала начальное и конечное сальдо в ИХ файлах может отличаться. Если это так - обращаем внимание только на начальное сальдо в тех месяцах у которых начальное и конечное отличаются</li>
                <li>После сведения сальдо надо обновить финансовую систему </li>
                <li>Когда завершится пересчет фин системы нужно показать квитанции за предпоследний месяц</li>
              </ul>
            </div>
          </app-panel>
        </div>
      </div>
      <div class="import-finance-stage-sidebar__col import-finance-stage-sidebar__col50">
        <div class="import-finance-stage-sidebar__col-content">
          <ImportStartSalaryPanel :importInfo="importInfo"/>
        </div>
        <div class="import-finance-stage-sidebar__col-content">
          <ImportSaldoPanel :importInfo="importInfo"/>
        </div>
      </div>
    </div>

    <div class="import-finance-stage-sidebar__row">
      <div class="import-finance-stage-sidebar__col">
        <div class="import-finance-stage-sidebar__col-content">
          <CheckSaldoPanel :importInfo="importInfo" @open-payments="openAccountPayments"/>
        </div>
      </div>
    </div>

    <div class="import-finance-stage-sidebar__row">
      <div class="import-finance-stage-sidebar__col">
        <div class="import-finance-stage-sidebar__col-content">
          <PaymentsPanel :importInfo="importInfo" ref="paymentsPanel"/>
        </div>
      </div>
    </div>

    <div class="import-finance-stage-sidebar__row">
      <div class="import-finance-stage-sidebar__col import-finance-stage-sidebar__col50" style="margin: 0 auto;">
        <div class="import-finance-stage-sidebar__col-content">
          <ActionsPanel :importInfo="importInfo" @update-queue="$emit('update-queue', $event)" @update-stage="$emit('update-stage')"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ImportStartSalaryPanel from "./panels/ImportStartSalaryPanel";
  import ImportSaldoPanel from "./panels/ImportSaldoPanel";
  import ActionsPanel from "./panels/ActionsPanel";
  import CheckSaldoPanel from "./panels/CheckSaldoPanel";
  import PaymentsPanel from "./panels/PaymentsPanel";



  export default {
    name: "ImportFinanceStageSidebar",
    components: {
      ActionsPanel,
      ImportSaldoPanel,
      ImportStartSalaryPanel,
      CheckSaldoPanel,
      PaymentsPanel
    },
    props: {
      importInfo: {}
    },
    methods: {
      openAccountPayments(account){
        this.$refs.paymentsPanel.getPaymentsByAccountNumber(account);
      }
    }
  }
</script>

<style lang="scss">
  .import-finance-stage-sidebar{
    padding-top: 15px;

    &__row{
      display: flex;
      flex-wrap: wrap;
      margin: 0 -7.5px;
    }

    &__col{
      flex: 1;
      padding: 0 7.5px;

      &50{
        flex: 0 0 50%;
      }

      &-content{
        margin-bottom: 15px;
      }
    }



    &__medium{
      font-weight: 600;
    }

    &__timeline{
      border-left: 1px solid rgba(0, 0, 0, .2);
      margin-left: 5px;

      /*padding: 15px 0;*/

      li{
        padding-left: 15px;
        position: relative;
        line-height: 1.1;

        &{
          padding-bottom: 20px;
          padding-top: 20px;
        }


        &::before{
          content: "";
          border: 2px solid rgba(var(--app-primary), 1);
          background: #fff;
          left: -8.5px;
          position: absolute;
          top: 50%;
          width: 11px;
          height: 11px;
          border-radius: 50%;
          transform: translateY(-50%);
        }
      }
    }
  }
</style>